module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel5-fr-FR-6a8197dfeabbd95632a60d019a18e050.png";